import { render, staticRenderFns } from "./CampusTransferPrint.vue?vue&type=template&id=f9dd7d8c&scoped=true&"
import script from "./CampusTransferPrint.vue?vue&type=script&lang=js&"
export * from "./CampusTransferPrint.vue?vue&type=script&lang=js&"
import style0 from "./CampusTransferPrint.vue?vue&type=style&index=0&id=f9dd7d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9dd7d8c",
  null
  
)

export default component.exports